import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-markdown'
import 'ace-builds/src-noconflict/theme-xcode'
import 'ace-builds/src-noconflict/ext-searchbox'
import { useSkillForm } from './SkillFormContext'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    borderBottom: '1px solid var(--color-neutral-200)',
    fontSize: 'var(--text-size-sm)',
    fontWeight: 600,
    color: 'var(--color-neutral-600)',
    flexShrink: 0
  },
  body: {
    flex: 1,
    overflow: 'hidden'
  }
}))

function InstructionsPanel () {
  const classes = useStyles()
  const form = useSkillForm()

  const handleChange = useCallback((val) => {
    form.setInstructions(val)
  }, [form])

  return (
    <div className={classes.root}>
      <div className={classes.header}>Instructions</div>
      <div className={classes.body}>
        <AceEditor
          mode='markdown'
          theme='xcode'
          name='skill-instructions-editor'
          value={form.instructions}
          onChange={handleChange}
          width='100%'
          height='100%'
          fontSize={13}
          showPrintMargin={false}
          showGutter
          highlightActiveLine
          placeholder='Write skill instructions in markdown...'
          wrapEnabled
          editorProps={{ $blockScrolling: true }}
          setOptions={{
            showLineNumbers: true,
            tabSize: 2,
            wrap: true
          }}
        />
      </div>
    </div>
  )
}

export default InstructionsPanel
